import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Table } from "antd";
import { tableStringSorter } from "../../utils/table";
import { WEEKLY, MONTHLY, QUARTERLY, YEARLY, BIANNUALLY } from "../../utils/report";
import { HomePageTable } from "../Common";

const ReportBulkEditTable = ({ frequency, isAdminUser, tableData, selectedRowKeys, setSelectedRowKeys }) => {
  return (
    <HomePageTable>
      <Table
        columns={[
          {
            title: "Hotel Code",
            dataIndex: "hotel_id",
            fixed: "left",
            // editable: false,
            width: "200px",
            sorter: tableStringSorter("hotel_id"),
          },
          {
            title: "Report Name",
            dataIndex: "ReportName",
            fixed: "left",
            width: "200px",
            sorter: tableStringSorter("ReportName"),
          },
          {
            title: "PMS Report Name",
            dataIndex: "PMSReportName",
            width: "250px",
            sorter: tableStringSorter("PMSReportName"),
          },
          {
            title: "Report Frequency",
            dataIndex: "shedule_type",
            width: "200px",
          },
          {
            title: "Report Category",
            dataIndex: "report_category",
            width: "200px",
            sorter: tableStringSorter("report_category"),
          },
          {
            title: "Signature Type",
            dataIndex: "signature_type",
            width: "200px",
            sorter: tableStringSorter("signature_type"),
          },
          {
            title: "Report Order",
            dataIndex: "ReportOrder",
            width: "200px",
            defaultSortOrder: "ascend",
            sorter: (a, b) =>
              (typeof a.ReportOrder !== "number" ? 99999999 : a.ReportOrder) -
              (typeof b.ReportOrder !== "number" ? 99999999 : b.ReportOrder),
          },
          {
            title: "Signature Mandatory",
            dataIndex: "SignatureMandatory",
            width: "250px",
            sorter: tableStringSorter("SignatureMandatory"),
          },
          {
            title: "Smart Scan",
            dataIndex: "smart_scan_type",
            width: "200px",
            sorter: tableStringSorter("smart_scan_type"),
          },
          {
            title: "Generate Redact Files",
            dataIndex: "enable_redaction",
            width: "200px",
            sorter: tableStringSorter("enable_redaction"),
          },
          {
            title: "Generate Flat Files",
            dataIndex: "export_flat_files",
            width: "200px",
            sorter: tableStringSorter("export_flat_files"),
          },
          {
            title: "Split Reports By Sub Header Type",
            dataIndex: "split_by_sub_header",
            width: "200px",
            sorter: tableStringSorter("split_by_sub_header"),
          },
          {
            title: "Document Type",
            dataIndex: "document_type",
            width: "300px",
            sorter: tableStringSorter("document_type"),
          },
          {
            title: "Submission Method",
            dataIndex: "SourceType",
            width: "200px",
            sorter: tableStringSorter("SourceType"),
          },
          {
            title: "myDocs Report Type",
            dataIndex: "mydocs_report_type",
            width: "200px",
            sorter: tableStringSorter("mydocs_report_type"),
          },
          ...([MONTHLY, QUARTERLY, BIANNUALLY, YEARLY].includes(frequency)
            ? [
                {
                  title: "Schedule Type",
                  dataIndex: "schedule_trigger_type",
                  width: "150px",
                  editable: true,
                },
              ]
            : []),
          ...([BIANNUALLY].includes(frequency)
            ? [
                {
                  title: "Schedule",
                  dataIndex: "schedule_trigger_data",
                  key: "schedule_trigger_data",
                  width: "150px",
                  editable: true,
                },
              ]
            : []),
          ...([WEEKLY, MONTHLY, QUARTERLY, YEARLY].includes(frequency)
            ? [
                {
                  title: "Schedule",
                  dataIndex: "schedule_weekday",
                  key: "schedule_weekday",
                  width: "150px",
                  editable: true,
                },
              ]
            : []),
          ...([MONTHLY, QUARTERLY, YEARLY].includes(frequency)
            ? [
                {
                  title: "Month",
                  dataIndex: "schedule_months",
                  key: "schedule_months",
                  width: "150px",
                  editable: true,
                  sorter: tableStringSorter("schedule_months"),
                },
              ]
            : []),
          {
            title: "Business Date",
            dataIndex: "business_date",
            width: "200px",
          },
          {
            title: "Subjects",
            dataIndex: "emailSubjects",
            width: "200px",
            sorter: tableStringSorter("emailSubjects"),
            // ...this.getColumnSearchProps("emailSubjects", type),
          },
          {
            title: "File Names",
            dataIndex: "filenames",
            width: "200px",
            sorter: tableStringSorter("filenames"),
            // ...this.getColumnSearchProps("filenames", type),
          },
          {
            title: "File Extension",
            dataIndex: "FileExtension",
            width: "200px",
            sorter: tableStringSorter("FileExtension"),
            // ...this.getColumnSearchProps("FileExtension", type),
          },
          {
            title: "File Mapping Name",
            dataIndex: "FileMappingName",
            width: "200px",
            sorter: tableStringSorter("FileMappingName"),
            // ...this.getColumnSearchProps("FileMappingName", type),
          },
          {
            title: "QC Ignored Report",
            dataIndex: "QC_IgnoredReport",
            width: "200px",
            sorter: tableStringSorter("QC_IgnoredReport"),
          },
          {
            title: "Compliance",
            dataIndex: "ComplianceEnabled",
            width: "200px",
            sorter: tableStringSorter("ComplianceEnabled"),
          },
          {
            title: "Report Name Matching Condition",
            dataIndex: "report_name_matching_condition",
            width: "240px",
          },
          {
            title: "File Extension Mapping",
            dataIndex: "file_extension_mapping",
            width: "200px",
          },
          {
            title: "Activation Date",
            dataIndex: "activation_date",
            width: "200px",
            editable: true,
          },
          {
            title: "Deactivation Date",
            dataIndex: "deactivation_date",
            width: "200px",
          },
          {
            title: "Signature Activation Date",
            dataIndex: "signature_activation_date",
            width: "200px",
          },
          {
            title: "Signature Deactivation Date",
            dataIndex: "signature_deactivation_date",
            width: "200px",
          },
          ...(isAdminUser
            ? [
                {
                  title: "Solution",
                  dataIndex: "report_type",
                  width: "200px",
                },
              ]
            : []),
          {
            title: "Created by",
            dataIndex: "create_by",
            width: "200px",
          },
          {
            title: "Created at",
            dataIndex: "create_at",
            width: "200px",
          },
          {
            title: "Updated by",
            dataIndex: "update_by",
            width: "200px",
          },
          {
            title: "Updated by",
            dataIndex: "update_at",
            width: "200px",
          },
        ]}
        dataSource={tableData}
        rowKey="_id"
        pagination={false}
        scroll={{ x: 4200 }}
        rowSelection={{
          onChange: (rowKeys) => {
            setSelectedRowKeys(rowKeys);
          },
          selectedRowKeys,
        }}
      />
    </HomePageTable>
  );
};

ReportBulkEditTable.propTypes = {};

const mapStateToProps = (state) => {
  return {
    isAdminUser: state.api?.permission?.sm_solution_access,
  };
};

export default connect(mapStateToProps, null)(ReportBulkEditTable);
